var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"span",staticClass:"font-bold rounded-md px-2 flex items-center border-2",class:{
    [_vm.bgClass]: true,
    [_vm.hoverClass]: _vm.hoverable,
    [_vm.textColor]: true,
    [_vm.borderColor]: true,
  },attrs:{"title":_vm.title}},'span',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }